export default "__VITE_ASSET__5e7Hd8FE__"